import type { StorySectionKey } from "@/lib/orgStory";

/**
 * Reader-facing section names (spec 2026-09-24 §5.1). Deliberately differ from
 * the editor's chapter labels where those are jargon ("Reach", "Operations").
 */
export interface StorySectionLabel {
  pill: string;
  eyebrow: string;
  title: string;
}

export const STORY_SECTION_LABELS: Record<StorySectionKey, StorySectionLabel> = {
  overview: { pill: "Overview", eyebrow: "Overview", title: "Our story" },
  offer: { pill: "The offer", eyebrow: "The offer", title: "How it works for agents" },
  growth: { pill: "Growth", eyebrow: "Growth", title: "Training and onboarding" },
  operations: { pill: "How it runs", eyebrow: "How it runs", title: "Tools and support" },
  footprint: { pill: "Footprint", eyebrow: "Footprint", title: "Where they work and how they perform" },
  team: { pill: "Team", eyebrow: "Team", title: "Leadership and agents" },
  reviews: { pill: "Reviews", eyebrow: "Reviews & culture", title: "What agents say" },
  news: { pill: "News", eyebrow: "News", title: "Latest from the team" },
};

export const storySectionAnchor = (key: StorySectionKey): string => `story-${key}`;
